module.exports = __webpack_public_path__ + "img/center21.2ecf3df4.png";